import { render, staticRenderFns } from "./CompareReasonsItemBox.vue?vue&type=template&id=2cf08b2f&"
import script from "./CompareReasonsItemBox.vue?vue&type=script&lang=js&"
export * from "./CompareReasonsItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports